import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for Confluence whiteboard diagramming.
 */
type ConfluenceWhiteboardDiagrammingData = {
	/**
	 * The diagramming response.
	 */
	document: string;
};

/**
 * Properties for the Confluence whiteboard diagramming command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceWhiteboardDiagrammingCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the whiteboard diagramming request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the whiteboard diagramming.
	 */
	data: ConfluenceWhiteboardDiagrammingData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to start a Confluence whiteboard diagramming.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to start a Confluence whiteboard diagramming.
 */
export const ConfluenceWhiteboardDiagrammingCommand =
	createCommand<ConfluenceWhiteboardDiagrammingCommandProperties>(
		'confluence-whiteboard-diagramming-command',
	);
